import styled from 'styled-components'

/**
 * Styled component is used to decorate CardWrapper component.
 * Props are passed from ThemeProvider component.
 */

export const BasketAddonCardStyle = styled.div`
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%);
  margin: 0em 1em 1em 1em;
  background-color: ${(props) =>
    props.theme.card?.backgroundColor ||
    props.theme.colors?.background ||
    '#D8D2E8'};
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 97%;
  color: ${(props) =>
    props.theme.card?.color || props.theme.colors?.primary || '#000000'};
`

export const BasketAddonCardRowStyle = styled.div`
  background-color: ${(props) =>
    props.theme.card?.backgroundColor ||
    props.theme.colors?.background ||
    '#D8D2E8'};
  display: flex;
  width: 99%;
  margin: 0.5em 1em 1em 1em;
  justify-content: space-between;
  flex-direction: row;
  color: ${(props) =>
    props.theme.card?.color || props.theme.colors?.primary || '#000000'};
`
